var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 50,
    rx: 5,
    fill: "#2a2a2a",
    stroke: "#444"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 15,
    x2: 80,
    y2: 15,
    stroke: "#555",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 25,
    x2: 70,
    y2: 25,
    stroke: "#555",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 35,
    x2: 75,
    y2: 35,
    stroke: "#555",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogWidget);
export default __webpack_public_path__ + "static/media/log-widget.0957fd52f3ce4e321fff8beb74afdd26.svg";
export { ForwardRef as ReactComponent };